// MEDICAL_INSURANCE_COMPANIES
export const SUPPORTED_CARRIERS = [
  [null, "--"],
  ["aetna", "Aetna"],
  ["aflac", "AFLAC"],
  ["allways_health", "AllWays Health Partners"],
  ["amerihealth", "AmeriHealth"],
  ["anthem", "Anthem"],
  ["asuris", "Asuris Northwest Health"],
  ["avmed", "AvMed"],
  ["allstate", "Allstate"],
  ["bcbs", "Blue Cross Blue Shield"],
  ["blue_shield", "Blue Shield"],
  ["blue_choice", "BlueChoice"],
  ["cal_choice", "Cal Choice"],
  ["capital_bluecross", "Capital BlueCross"],
  ["careconnect", "CareConnect"],
  ["carefirst_bcbs", "CareFirst BCBS"],
  ["choice_builder", "Choice Builder"],
  ["cigna", "Cigna"],
  ["cigna_oscar", "Cigna + Oscar"],
  ["delta_dental", "Delta Dental"],
  ["dental_care_plus", "Dental Care Plus"],
  ["dental_select", "Dental Select"],
  ["emblem_health", "EmblemHealth"],
  ["empire_bcbs", "Empire BCBS"],
  ["excellus_bcbs", "Excellus BCBS"],
  ["fallon", "Fallon Health"],
  ["florida_blue", "Florida Blue"],
  ["geisinger", "Geisinger Health Plan"],
  ["group_health", "Group Health"],
  ["guardian", "Guardian"],
  ["harvard_pilgrim", "Harvard Pilgrim"],
  ["health_net", "Health Net"],
  ["health_new_england", "Health New England"],
  ["health_republic", "Health Republic"],
  ["health_first", "Health First"],
  ["health_partners", "Health Partners"],
  ["healthy_ct", "Healthy CT"],
  ["highmark", "Highmark"],
  ["horizon_bcbs", "Horizon BCBS"],
  ["humana", "Humana"],
  ["independence_bc", "Independence Blue Cross"],
  ["kaiser", "Kaiser"],
  ["medical_mutual", "Medical Mutual"],
  ["memorial_hermann", "Memorial Hermann Health Solutions"],
  ["oscar", "Oscar"],
  ["oxford", "Oxford"],
  ["premera", "Premera"],
  ["priority_health", "Priority Health"],
  ["providence", "Providence"],
  ["regence", "Regence"],
  ["SBMA", "SBMA"],
  ["selecthealth", "SelectHealth"],
  ["sentara_health_plans", "Sentara Health Plans"],
  ["sharp", "Sharp"],
  ["sun_life", "Sun Life"],
  ["tufts", "Tufts Health Plan"],
  ["trustmark", "Trustmark"],
  ["united_healthcare", "UnitedHealthcare"],
  ["upmc", "UPMC"],
  ["upmc", "UPMC Blue Cross Blue Shield"],
  ["vsp", "VSP"],
  ["other", "Other"],
];

export const SUPPORTED_CARRIER_HASH = Object.fromEntries(SUPPORTED_CARRIERS);

export const SUPPORTED_LIFE_CARRIERS = [
  [null, "--"],
  ["aflac", "Aflac"],
  ["chubb", "Chubb"],
  ["cigna", "Cigna"],
  ["colonial_life", "Colonial Life"],
  ["guardian", "Guardian"],
  ["the_hartford", "The Hartford"],
  ["lincoln", "Lincoln"],
  ["lincoln_financial_group", "Lincoln Financial Group"],
  ["liberty_mutual", "Liberty Mutual"],
  ["metlife", "MetLife"],
  ["mutual_of_omaha", "Mutual of Omaha"],
  ["prudential", "Prudential"],
  ["reliance_matrix", "Reliance Matrix"],
  ["reliance_standard", "Reliance Standard"],
  ["the_standard", "The Standard"],
  ["securian", "Securian"],
  ["sun_life_financial", "Sun Life Financial"],
  ["united_healthcare", "UnitedHealthcare"],
  ["unum", "Unum"],
  ["voya", "Voya"],
  ["other", "Other"],
];
export const SUPPORTED_LIFE_CARRIER_HASH = Object.fromEntries(SUPPORTED_LIFE_CARRIERS);

export const SUPPORTED_DISABILITY_CARRIERS = [
  [null, "--"],
  ["cigna", "Cigna"],
  ["guardian", "Guardian"],
  ["the_hartford", "The Hartford"],
  ["liberty_mutual", "Liberty Mutual"],
  ["lincoln_financial_group", "Lincoln Financial Group"],
  ["metlife", "MetLife"],
  ["mutual_of_omaha", "Mutual of Omaha"],
  ["prudential", "Prudential"],
  ["reliance_standard", "Reliance Standard"],
  ["the_standard", "The Standard"],
  ["unum", "Unum"],
  ["other", "Other"],
];

export const FORM_NAME = "brokerOfRecord";

// Define supported insurance types and labels
export const INSURANCE_TYPE_OPTIONS = [
  { value: "medical", label: "Medical" },
  { value: "dental", label: "Dental" },
  { value: "vision", label: "Vision" },
  { value: "termLife", label: "Term Life" },
  { value: "wholeLife", label: "Whole Life" },
  { value: "shortTermDisability", label: "Short Term Disability" },
  { value: "longTermDisability", label: "Long Term Disability" },
];
